import { FindTwoInLine, RandomMove } from "./MiscGameFunctions";

function ComputerMoveNovice(squares) {

    let desiredMove = -1;

    // if we are about to win we need to place the third "O"
    desiredMove = FindTwoInLine("O", squares);
    if (desiredMove > -1) {
        return desiredMove;
    }

    // if the human is about to win we need to block them
    desiredMove = FindTwoInLine("X", squares);
    if (desiredMove > -1) {
        return desiredMove;
    }

    // Otherwise, look at the board and find a random empty spot anywhere
    return RandomMove(squares);
};

export default ComputerMoveNovice;